import React, { Component } from "react"
import withStyles from "@material-ui/styles/withStyles"
import { withRouter } from "react-router-dom"
import CssBaseline from "@material-ui/core/CssBaseline"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from "@material-ui/core"
import firebase from 'firebase'

import Back from "../../components/Common/Back"
import Logo from '../../components/Logo'
import Zero from "../../components/Steps/Zero"
import OneAsOne from "../../components/Steps/OneAsOne"
import Two from "../../components/Steps/Two"
import ThreeAsOne from "../../components/Steps/ThreeAsOne"
import Four from "../../components/Steps/Four"
import { server } from "../../server"
import Footer from "../../components/Common/Footer"
import AwaitingContainer from "../../components/Steps/AwaitingContainer"
import { dbPrefix } from "../../Constants"
import { validateEmail, validateCpf } from "../../utils"

const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: '30px',
  },
  grid: {
    margin: `0 ${theme.spacing(2)}px`
  },
  bigContainer: {
    display: 'flex',
    justifyContent: 'center',
    // width: "80%"
  },
  menuItem: {
    fontSize: '55%'
  },
  logo: {
    marginBottom: 24,
    display: "flex",
    justifyContent: "center",
  },
  stepContainer: {
    display: "flex",
    flexDirection: "column",
  },
  buttonBar: {
    marginTop: 32,
    marginBottom: 8,
    display: "flex",
    justifyContent: "center"
  },
  button: {
    backgroundColor: theme.palette.primary["A100"]
  },
  backButton: {
    marginRight: theme.spacing(1)
  },
  outlinedButtom: {
    textTransform: "uppercase",
    margin: theme.spacing(1)
  },
  stepper: {
    backgroundColor: "transparent",
    padding: 0
  },
  paper: {
    margin: '10px',
    padding: theme.spacing(3),
    textAlign: "left",
    color: theme.palette.text.secondary
  },
  topInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 42
  },
  formControl: {
    width: "100%",
    margin: '7px 0px',
    flex: 1
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
})

const getSteps = () => {
  return ["Tipo de Inscrição", "Cadastro", "Termo de Permissão e Sigilo", "Confirmação"]
}

const initialState = {
  activeStep: 0,
  userType: null,
  knowledgeArea: null,
  email: "",
  name: "",
  cpf: "",
  videoLink: "",
  users: [
    { uName: "", uEmail: "", ucpf: "" },
  ],
  paperTitle: "",
  abstract: "",
  openModal: false,
  paperFile: false,
  termsChecked: false,
  loading: false,
  labelWidth: 0
}

class SignupParticipantsOnly extends Component {
  state = initialState
  handleStart = this.handleStart.bind(this)

  handleSubmit = async e => {

    e.preventDefault()
    this.setState({ loading: true, message: false })

    if (this.state.activeStep !== 3) {
      return false
    }

    const { userType, name, cpf, email } = this.state

    if (userType === "1") {

      // estruturado
      const user = {
        type: userType,
        uEmail: email,
        uName: name,
        ucpf: cpf,
        secondWave: true
      }

      const data = {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          users: [user]
        })
      }

      firebase.database()
        .ref(dbPrefix + 'users/' + cpf)
        .set(user)
        .then(() => {
          fetch(server + '/subscription', data)
            .catch(error => {
              console.log(error)
              let message
              message = "Ok! Sua inscrição foi cadastrada. Em breve você receberá um e-mail como confirmação de inscrição."
              return this.setState({ success: true, message, loading: false })
            })
            .then(res => res.json()
              .then((resp) => {
                let message
                if (resp.status === 200) {
                  message = "Sucesso! Sua inscrição foi cadastrada. Em breve você receberá um e-mail como confirmação de inscrição."
                  return this.setState({ success: true, message, loading: false })
                } else {
                  message = "Ok! Sua inscrição foi cadastrada. Em breve você receberá um e-mail como confirmação de inscrição."
                  return this.setState({ success: true, message, loading: false })
                }
              })
              .catch(error => {
                console.log(error)
                return this.setState({ error: true, message: "Ocorreu um erro... Tente novamente.", loading: false })
              })
            )
        }).catch(error => {
          console.log(error)
          return this.setState({ error: true, message: "Ocorreu um erro... Tente novamente.", loading: false })
        })
    }
  }

  handleNext = async (e) => {
    // Step 0
    this.setState({ loading: true })

    if (!this.state.userType) {
      this.setState({ loading: false })
      return this.setState({ openModal: true, title: "Tipo de Inscrição Inválida", description: "Você precisa selecionar um tipo de inscrição" })
    }

    // Checa validez dos dados do participante
    if (this.state.userType === "1") {
      if (this.state.activeStep === 1) {
        if (!this.state.name) {
          this.setState({ loading: false })
          return this.setState({ openModal: true, title: "Nome Vazio", description: "Você precisa preencher um nome" })
        }
        if (this.state.name < 4) {
          this.setState({ loading: false })
          return this.setState({ openModal: true, title: "Nome Inválido", description: "Você precisa inserir um nome válido" })
        }
        if (!this.state.cpf) {
          this.setState({ loading: false })
          return this.setState({ openModal: true, title: "CPF Vazio", description: "Você precisa preencher um CPF" })
        }
        if (!validateCpf(this.state.cpf) || this.state.cpf.length !== 11) {
          this.setState({ loading: false })
          return this.setState({ openModal: true, title: "CPF Inválido", description: "Você precisa inserir um CPF válido" })
        }

        try {
          // Checa participante
          const inDB = await this.checkAsParticipant(this.state.cpf)
          if (!!inDB) {
            this.setState({ loading: false })
            return this.setState({ openModal: true, title: "Participante Inválido", description: "Este participante já está cadastrado" })
          }
        } catch (error) {
          this.setState({ loading: false })
          return this.setState({ openModal: true, title: "Ocorreu um erro", description: "Erro ao verificar participante" })
        }

        if (!this.state.email) {
          this.setState({ loading: false })
          return this.setState({ openModal: true, title: "E-mail Vazio", description: "Você precisa preencher um e-mail" })
        }
        if (!validateEmail(this.state.email)) {
          this.setState({ loading: false })
          return this.setState({ openModal: true, title: "E-mail Inválido", description: "Você precisa inserir um e-mail válido" })
        }
      }
    }

    if (this.state.activeStep === 2) {
      if (!this.state.termsChecked) {
        this.setState({ loading: false })
        return this.setState({ openModal: true, title: "Termo de Permissão e Sigilo não aceito", description: "Por favor, leia o texto e caso concorde, marque como 'Eu li e concordo com o Termo de Permissão e Sigilo'" })
      }
    }
    if (this.state.activeStep === 3) {
      this.handleSubmit(e)
      this.setState({ loading: false })
      return this.setState({ activeStep: this.state.activeStep + 1 })
    }
    this.setState({ loading: false })
    return this.setState({ activeStep: this.state.activeStep + 1 })
  }

  checkAsParticipant = async cpf => {
    // Checa se existe como inscrito
    const snapshot = await firebase.database()
      .ref(dbPrefix + 'users')
      .orderByChild('ucpf')
      .equalTo(cpf)
      .once('value')
    return snapshot.val()
  }

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1
    }))
  }

  handleFileChange = e => {
    let ext = e.target.files[0].name.split('.')[1]
    if (ext !== 'docx' && ext !== 'doc') {
      this.setState({ loading: false })
      return this.setState({ paperFile: false, openModal: true, title: "Extensão de arquivo Inválida", description: "Você precisa inserir uma Extensão de arquivo válida (.doc ou .docx)" })
    }
    this.setState({ loading: false })
    return this.setState({ paperFile: e.target.files[0] })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleTerms = event => {
    this.setState({ termsChecked: event.target.checked })
  }

  stepActions = () => {
    if (this.state.activeStep === 3) {
      return "Finalizar"
    }
    return "Próximo"
  }

  handleClose = () => {
    this.setState({ openModal: false })
  }

  handleStart(e) {
    e.preventDefault()
    return this.props.history.push('/')
  }
  tryAgain = () => {
    return this.setState({ initialState })
  }
  render() {
    const { classes } = this.props
    const steps = getSteps()
    const { activeStep, loading, userType, email, name, cpf, openModal, title, description, success, error, message, termsChecked } = this.state

    return (
      <React.Fragment>
        <CssBaseline />
        <div className={classes.root}>
          <Back />
          <Grid container justify="center">
            <Grid
              alignItems="center"
              container
              className={classes.grid}>
              <Grid item xs={12}>
                <div className={classes.logo}>
                  <Logo />
                </div>

                <div className={classes.stepContainer}>
                  <div className={classes.stepGrid}>
                    {/* Modal Dialog */}
                    <Dialog
                      open={openModal}
                      onClose={this.handleClose}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.handleClose} color="primary">Ok</Button>
                      </DialogActions>
                    </Dialog>
                    {/* Fim modal */}

                    <Stepper
                      classes={{ root: classes.stepper }}
                      activeStep={activeStep}
                      // nonLinear
                      alternativeLabel
                    >
                      {steps.map(label => {
                        return (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        )
                      })}
                    </Stepper>
                  </div>
                  <form>
                    {
                      loading && activeStep !== 4 ? (
                        <AwaitingContainer
                          classes={classes}
                        />
                      )
                        :
                        <div>
                          {activeStep === 0 && (
                            <Zero
                              participantsOnly
                              userType={userType}
                              classes={classes}
                              handleChange={this.handleChange}
                              labelWidth={this.state.labelWidth}
                            />
                          )}
                          {activeStep === 1 && (
                            <OneAsOne
                              classes={classes}
                              handleChange={this.handleChange}
                              name={name}
                              cpf={cpf}
                              email={email}
                            />
                          )}
                          {activeStep === 2 && (
                            <Two
                              userType={userType}
                              termsChecked={termsChecked}
                              handleTerms={this.handleTerms}
                              classes={classes}
                            />
                          )}
                          {activeStep === 3 && (
                            <ThreeAsOne
                              classes={classes}
                              name={name}
                              cpf={cpf}
                              email={email}
                            />
                          )}
                          {activeStep === 4 && (
                            <Four
                              classes={classes}
                              error={error}
                              success={success}
                              message={message}
                              tryAgain={this.tryAgain}
                              goBack={this.handleStart}
                            />
                          )}
                          {/* Btns */}
                          {activeStep !== 4 && (
                            <div className={classes.buttonBar}>
                              <Button
                                disabled={activeStep === 0}
                                onClick={this.handleBack}
                                className={classes.backButton}
                                size="large">
                                Voltar
                            </Button>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={this.handleNext}
                                size="large">
                                {this.stepActions()}
                              </Button>
                            </div>
                          )}
                        </div>
                    }
                  </form>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div >
        <Footer />
      </React.Fragment >
    )
  }
}

export default withRouter(withStyles(styles)(SignupParticipantsOnly))